import React from "react";

/**
 * Read-only URL field shown when the Clipboard API failed, so the user can
 * copy the link by hand. Autofocused and select-on-focus: appearing already
 * selected is the whole point of the fallback.
 *
 * Shared by SharePopover and EmbedInNotion, which had byte-identical copies.
 */
export const ManualCopyField: React.FC<{
  value: string;
  /** Test hook; each call site keeps its own existing id. */
  "data-testid"?: string;
}> = ({ value, "data-testid": testId }) => (
  <input
    // eslint-disable-next-line jsx-a11y/no-autofocus -- select once on first appearance, not on every re-render
    autoFocus
    data-testid={testId}
    type="text"
    readOnly
    value={value}
    onFocus={(e) => e.currentTarget.select()}
    style={{
      padding: "0.5rem 0.6rem",
      borderRadius: "0.5rem",
      border: "1px solid var(--default-border-color)",
      fontSize: "0.8rem",
      // Not `--background-color-hover`: that token is defined nowhere, so it
      // always resolved to the near-white fallback - a white field inside the
      // dark share popover, under theme-coloured (light) text.
      background: "var(--color-surface-high)",
      color: "var(--text-primary-color)",
    }}
  />
);

export default ManualCopyField;
